module.exports = __webpack_public_path__ + "static/media/belfast-win.2a2532e1.png";